import React, { useState, useRef } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const ContactForm = () => {
    const [captcha, setCaptcha] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: "", message: "" });
    const recaptchaRef = useRef(null);

    const handleSubmit = async () => {
        setStatus({ type: "", message: "" });

        if (!captcha) {
            setStatus({
                type: "error",
                message: "Please complete the captcha."
            });
            return;
        }

        try {
            setLoading(true);
            await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/api/contact/send`, {
                name, from: email, text: message, captcha,
            });

            setName("");
            setEmail("");
            setMessage("");
            setCaptcha(null);
            recaptchaRef.current?.reset();

            setStatus({
                type: "success",
                message: "Email has been sent successfully."
            });
        } catch (err) {
            const errMessage =
                err.response?.data?.error?.message ||
                err.response?.data?.message ||
                "Failed to send your message. Please try again or email us directly.";
            setStatus({
                type: "error",
                message: errMessage
            });
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="contact-form" action="#" method="POST">
            <div className="form-row">
                <div className="form-group">
                    <input 
                        type="text" 
                        onChange={(e) => setName(e.target.value)} 
                        value={name} 
                        placeholder=" " 
                        required 
                        name="name" 
                    />
                    <label>Name</label>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <input 
                        type="email" 
                        onChange={(e) => setEmail(e.target.value)} 
                        value={email} 
                        placeholder=" " 
                        required 
                        name="Email" 
                    />
                    <label>Email</label>
                </div>
            </div>
            <div className="form-group">
                <textarea 
                    rows="5" 
                    onChange={(e) => setMessage(e.target.value)} 
                    value={message} 
                    placeholder=" " 
                    required 
                    name="Message" 
                />
                <label>Message</label>
            </div>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LeFmfYsAAAAAP4pXku7a7nTT1AEdZyduSvj_c2H"
                onChange={setCaptcha}
            />
            <button 
                type="button" 
                disabled={loading || !captcha} 
                onClick={handleSubmit}
            >
                {loading ? 'SUBMITTING...' : 'SUBMIT'}
            </button>
            {status.message && (
                <div 
                    style={{
                        marginTop: "20px",
                        padding: "12px 15px",
                        borderRadius: "4px",
                        fontSize: "15px",
                        fontWeight: "500",
                        border: `1px solid ${status.type === "success" ? "#c3e6cb" : "#f5c6cb"}`,
                        backgroundColor: status.type === "success" ? "#d4edda" : "#f8d7da",
                        color: status.type === "success" ? "#155724" : "#721c24",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                    }}
                >
                    {status.type === "success" ? "✓" : "⚠"} {status.message}
                </div>
            )}
        </form>
    );
};

export default ContactForm;
